import './navigation/gesture-handler';
import {Component} from 'react';
import {
  AppState,
  Dimensions,
  Platform,
  StyleSheet,
  View,
  LogBox
} from 'react-native';
import {GestureHandlerRootView} from 'react-native-gesture-handler';

import {ThreeDSecureAuthentModal} from './components/payments/ThreeDSecureAuthentModal';
import {Providers} from './components/providers';
import {trackAnalyticsEvent} from './lib/analytics';
import {store, persistor} from './lib/configure-store';
import {refreshTranslation} from './lib/i18n';
import Routing from './navigation/Routing';
import {BatchPush} from '@batch.com/react-native-plugin';
import {Appearance} from 'react-native';
import {
  setIsESimCompatibleToAsyncStorage,
} from './modules/ESim/eSIM';
import { PersistGate } from 'redux-persist/integration/react'
import { saveTaxExemptionByArea } from './lib/tripicaStaticConfig';
import WizzeeLog from './lib/wizzeeLog';
import {initSecureStorage} from './lib/secureStorage';

const LARGE_WIDTH = 1000;

class App extends Component {

  componentDidMount() {
    initSecureStorage();
    LogBox.ignoreAllLogs(); //Ignore all log notifications

    
    this.forceUpdate();
    refreshTranslation()
      .then(() => this.forceUpdate())
      .catch(() => {});
    setIsESimCompatibleToAsyncStorage().then(isESimCompatible => {
      isESimCompatible ? WizzeeLog.info('ESIM') : WizzeeLog.error('ESIM');
    });
    saveTaxExemptionByArea().catch(() => {});
    trackAnalyticsEvent('launch');
    AppState.addEventListener('change', appState => {
      if (appState !== 'active') {
        return;
      }
      trackAnalyticsEvent('resume');
    });

    if (Platform.OS !== 'web') {
      //Ask for notification authorization
      BatchPush.requestNotificationAuthorization();
    }
  }

  render() {
    if (Platform.OS !== 'web') {
      Appearance.setColorScheme('light');
    }

    const isLarge = Platform.OS !== 'web' && Dimensions.get('window').width > LARGE_WIDTH;
    return (
      <GestureHandlerRootView style={styles.gestureRoot}>
        <Providers store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <View style={[styles.container, isLarge && styles.largeContainer]}>
              <Routing />
              <ThreeDSecureAuthentModal />
            </View>
          </PersistGate>
        </Providers>
      </GestureHandlerRootView>
    );
  }
}

const styles = StyleSheet.create({
  gestureRoot: {
    flex: 1,
  },
  container: {
    flex: 1,
  },
  largeContainer: {
    marginHorizontal: '30%',
    alignSelf: 'stretch',
    shadowOpacity: 0.1,
    shadowColor: 'black',
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 0 },
  },
});

export default App;
